import React from "react";
import { Link, Navigate, Route, Routes } from "react-router-dom";
import ParentResult from "./ParentResult";
import Impressum from "./pages/Impressum";

import "./style.css";

// Hinweisbalken "Testphase" — vor dem Livegang auf false setzen
const SHOW_TEST_NOTICE = true;

function App() {
  return (
    <div className="App">
      {SHOW_TEST_NOTICE && (
        <div className="testNotice" role="status">
          <strong>⚠ Testphase:</strong> Diese Karte befindet sich im Aufbau. Die Angaben dienen zu Testzwecken und können fehlerhaft oder unvollständig sein.
        </div>
      )}

      {/* logo leads back to the map from any page */}
      <Link to="/" aria-label="Zur Karte">
        <img
          src="/moenchgut-logo.png"
          alt="Logo Mönchgut"
          style={{
            width: "150px",
            margin: "2em",
            height: "auto",
            objectFit: "contain",
            display: "block",
            marginTop: "10px",
          }}
        />
      </Link>

      <Routes>
        {/* MAIN APP */}
        <Route
          path="/"
          element={
            <div className="dataviz">
              <ParentResult />
            </div>
          }
        />
        {/* QR code on a sign: same map, centred on that location */}
        <Route
          path="/qr/:slug"
          element={
            <div className="dataviz">
              <ParentResult />
            </div>
          }
        />
        <Route path="/impressum" element={<Impressum />} />
        {/* unknown paths -> map */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <footer className="siteFooter">
        <span>
          Diese Karte dient ausschließlich der Orientierung. Alle Angaben erfolgen ohne Gewähr.
          Die Nutzung der Karte erfolgt auf eigene Verantwortung.
        </span>
        <span aria-hidden="true">·</span>
        <span>Inhalte: Kurverwaltung Mönchgut</span>
        <span aria-hidden="true">·</span>
        <span>Digitale Lösung: Wayfinding Expert GmbH</span>
        <span aria-hidden="true">·</span>
        <span>
          Kartendaten: © OpenStreetMap-Mitwirkende (
          <a
            href="https://www.openstreetmap.org/copyright"
            target="_blank"
            rel="noopener noreferrer"
          >
            ODbL
          </a> teilweise auf Basis von Shapefiles der Geofabrik
          )
        </span>
        <span aria-hidden="true">·</span>
        <Link to="/impressum">Impressum</Link>
      </footer>

      {/* 🧪 TEST AREA (nur Development) */}
      {process.env.NODE_ENV === "development" && (
        <section className="test"></section>
      )}
    </div>
  );
}

export default App;
